import React from 'react';
import './App.css';
import { AnimatePresence, motion } from 'framer-motion';
import blogimg from './blog-img.jpg';

class Blog extends React.Component {
    render() {
        return (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <div className="about-container">
                    <div>
                        <p>
                            Welcome to the blog – Tall Tree: Between Sessions - a space where you can explore ADHD, anxiety,
                            trauma, and mental health in a way that feels approachable, validating, and grounded in real-life
                            experience. Here, you’ll find therapist-informed insights, practical strategies, and compassionate
                            guidance to help you better understand yourself and navigate life with more clarity and confidence.
                        </p>
                        <p>If something resonates, you don’t have to figure it out alone—therapy can help you take the next step.</p>
                        <div className="link-button"><a href='https://talltreepsychotherapy.medium.com' target="_blank">Explore ADHD, anxiety, and trauma resources</a></div>
                        <img src={blogimg} className="image-b"></img>
                    </div>
                </div>
            </motion.div>
        )
    }
}

export default Blog;